/**
 * Partner referral tracking constants.
 *
 * Partner referral cookies are intentionally separate from the UTM attribution
 * stored in `src/lib/attribution`. The proxy-set code cookie records the latest
 * partner link/code seen by the visitor; the legacy JSON cookie is kept only
 * for the rollout transition.
 */

// Legacy cookie name that stores the referring partner.
export const PARTNER_REFERRAL_COOKIE = "avante_partner_ref";

// Server-set cookie that stores the latest partner slug or alias code.
export const PARTNER_REFERRAL_CODE_COOKIE = "avante_partner_code_ref";

// Referral window in days (matches the attribution window).
export const PARTNER_REFERRAL_WINDOW_DAYS = 30;

// Short-lived cookie that carries a typed alias code across a social sign-in
// redirect, where there is no post-auth client hook to claim it directly.
export const PARTNER_REFERRAL_TYPED_CODE_COOKIE = "avante_partner_code";

// Lifetime of the typed-code handoff cookie: long enough to complete an OAuth
// round-trip, short enough not to linger past the signup it belongs to. The
// server additionally deletes it the moment a user-create claim consumes it.
export const PARTNER_REFERRAL_TYPED_CODE_WINDOW_MINUTES = 10;

// UTM values appended to partner CTAs so partner traffic shows in funnels.
export const PARTNER_UTM_SOURCE = "partner";
